module.exports = __webpack_public_path__ + "media/images/clattenburg-blank-c09d6ccb8c3d3201992fd69335ec6aa7.png";